/* eslint-disable no-unused-vars */
import axios from "../../axios";

const urlFolderEmail = "/template-folders";

const state = {
  folders: [],
  pagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
  },
};

const actions = {
  /**
   * Get list students
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getLists({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlFolderEmail}?${new URLSearchParams(query)}`,
      );
      if (response.status === 200) {
        commit("SET_LIST_FOLDERS", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },

  /**
   * Create
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async create({ commit }, payload) {
    return await axios.post(urlFolderEmail, payload);
  },

  /**
   * Update
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async update({ commit }, { id, payload }) {
    return await axios.put(`${urlFolderEmail}/${id}`, payload);
  },

  /**
   * Delete
   * @param commit
   * @param id
   * @returns {Promise<AxiosResponse<any>>}
   */
  async delete({ commit }, id) {
    return await axios.delete(`${urlFolderEmail}/${id}`);
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};

const mutations = {
  // EDIT_DATA (state, itemId) {
  //   state.students.map(item => {
  //     item.isOpen = false
  //     return item
  //   })
  //   const userIndex = state.students.findIndex((u) => u.id === itemId)
  //   if (userIndex >= 0) {
  //     state.students[userIndex].isOpen = true
  //   }

  // },
  SET_LIST_FOLDERS(state, data) {
    state.folders = data.items;
    state.pagination = data.pagination;
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
